import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Row, Col, Card } from 'antd';
import { getSalaireById } from 'app/entities/salaire/salaire.reducer';
import { SalaireParams } from 'app/shared/model/salaire.model';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { RouteComponentProps, Link } from 'react-router-dom';
import { partialUpdateSalaire } from './salaire.reducer';
import DetailsSalaire from './DetailsSalaire';

const { Title } = Typography;

const TableTitle: React.FC<{ numeroSalaire: string }> = ({ numeroSalaire }) => (
  <Title level={5}>
    Salaire N° <span className="invoice-title">{numeroSalaire}</span>
  </Title>
);

const SalaireDetails = ({ match }: RouteComponentProps<SalaireParams>) => {
  const salaireId = match.params.salaireId;
  const ecoleId = match.params.ecoleid;
  const anneeScolaireId = match.params.anneeScolaireId;
  const dispatch = useAppDispatch();
  const { entity: salaire, loading } = useAppSelector(state => state.salaire);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const [editingMontantNet, setEditingMontantNet] = useState(false);
  const [montantNet, setMontantNet] = useState(salaire.montant);
  const [statutSalaire, setStatutSalaire] = useState(salaire.statutSalaire);
  const [processing, setProcessing] = useState(false);

  const handleMontantEdit = () => {
    if (editingMontantNet === false) {
      setEditingMontantNet(true);
      setMontantNet(salaire.montant);
    } else {
      setEditingMontantNet(false);
    }
  };

  const handleConfirm = () => {
    setProcessing(true);
    const updatedSalaire = { ...salaire, id: salaireId };
    if (editingMontantNet) {
      updatedSalaire.montant = montantNet;
    }

    dispatch(partialUpdateSalaire(updatedSalaire));
    setEditingMontantNet(false);

    setProcessing(false);
  };

  useEffect(() => {
    dispatch(getSalaireById(salaireId));
  }, [dispatch, salaireId]);

  return (
    <div>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/salaires/${ecoleId}/${anneeScolaireId}`}>Salaire</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/salaires/${ecoleId}/${anneeScolaireId}/${salaire.salaireGroupId}/list`}>Liste</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Détails</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col>
          <Card>
            <div className="invoice-header">
              <DetailsSalaire
                anneeScolaireId={anneeScolaireId}
                ecoleId={ecoleId}
                salaire={salaire}
                handleConfirm={handleConfirm}
                handleMontantEdit={handleMontantEdit}
                montantNet={montantNet}
                setMontantNet={setMontantNet}
                statutSalaire={statutSalaire}
                setStatutSalaire={setStatutSalaire}
                editingMontantNet={editingMontantNet}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SalaireDetails;
